module.exports = {"360735100":"琴江镇","360735101":"小松镇","360735102":"屏山镇","360735103":"横江镇","360735104":"高田镇","360735105":"赣江源镇","360735200":"木兰乡","360735201":"丰山乡","360735202":"大由乡","360735203":"龙岗乡","360735204":"珠坑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360735.json
// module id = 1415
// module chunks = 0